// skeleton/app/src/app/manage-group-users/manage-group-users.component.ts

import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
import { NotificationService } from 'src/app/shared/services/notifications.service';
import { ParamService } from 'src/app/shared/services/param.service';
import {
  faAlignJustify,
  faAngleLeft,
  faAngleRight,
  faCalendarAlt,
  faEdit,
  faPlus,
  faUserCircle
} from '@fortawesome/free-solid-svg-icons';
import { OrganizationModel } from '../admin/models/organization.model';
import { Constants } from 'src/app/shared/constants';
import { GroupModel, UserGroupModel, UserModel } from 'src/app/admin/models/group.model';
import { UserActivityLogModel } from 'src/app/shared/models/userActivityLog.model';
import { forkJoin, Observable, pipe } from 'rxjs';
import { AuthorizationService } from 'src/app/shared/services/authorization.service';
import { UserType } from 'src/app/admin/models/usertype.model';
import { SelectItem } from 'primeng/api';
import { UserTypeId } from 'src/app/shared/models/userType.model';
import { exit } from 'process';
import { Table, TableModule } from 'primeng/table';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { debounceTime, distinctUntilChanged, map, retry } from 'rxjs/operators';
import { ModalSize } from '../shared/components/view/modal/modal.model';
import { ButtonColors, ButtonSize, ButtonStyle, ButtonType } from '../shared/components/inputs/button/button.model';
import { debug } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSort, Sort } from '@angular/material/sort';
// 🛡️ Import RE2JS for safe regex operations to prevent ReDoS attacks
import { RE2JS } from 're2js';
import { StorageService } from '../shared/services/token-storage.service';

export interface Element {
  userid: string;
  fullName: string;
  email: string;
  userTypeDesc: string;
}

@Component({
  selector: 'app-manage-group-users',
  templateUrl: './manage-group-users.component.html',
  styleUrls: ['./manage-group-users.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false
})
export class ManageGroupUsersComponent implements OnInit {
  arrowIconToggle: boolean = false;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faUserCircle = faUserCircle;
  faAlignJustify = faAlignJustify;

  orgName: string = '';
  selectedOrgNameValue: string = '';
  showgroupContainer: boolean = false;
  selectedOrgEdit;

  Organization: OrganizationModel = new OrganizationModel();
  organizations: OrganizationModel[] = [];
  selectedOrgName: string;
  selectedOrgDesc: string;

  constant: Constants = new Constants();
  masterGroups: GroupModel[] = [];
  userActivity: UserActivityLogModel = new UserActivityLogModel();

  masterOrgs: OrganizationModel[] = [];
  selectedOrganization: [];
  orgs: OrganizationModel[];

  masterUsers: UserGroupModel[] = [];
  users: UserGroupModel[] = [];
  user: UserGroupModel;

  userTypeList: UserType[] = [];
  userList: UserGroupModel[] = [];
  userList1: UserGroupModel[] = [];
  userTypes: SelectItem[] = [];

  clonedUser: { [s: string]: UserGroupModel } = {};
  masterorgsfinal = [];

  rolefilter = [];
  fullnamefilter = [];
  emailfilter = [];

  Isdataloaded = true;
  group: GroupModel = new GroupModel();
  groups: GroupModel[] = [];
  selectedOrg: OrganizationModel;

  data: Element[] = [];
  displayedColumns: string[] = ['fullName', 'email', 'userTypeDesc', 'Supervisor', 'Actions'];
  size = 5;
  pageIndex = 0;
  dataSource: any;
  filter: {};

  modalSize = ModalSize.Large;
  modalText = 'Add New User Details';
  hidePopUp: boolean = true;
  modalbtnText = 'SAVE';
  editingrow: boolean = false;
  modalbtncancelText = 'CANCEL';
  modalbtnMedium = ButtonSize.Medium;
  modalbtnWithText = ButtonStyle.Textonly;
  modalbtnRect = ButtonType.Rectangle;
  modalbtnBlue = ButtonColors.Blue;

  IsAdd: boolean = false;
  btnSaveText = 'SAVE';
  btnDeleteText = 'DELETE';
  btnCancelText = 'CANCEL';

  deleteModalSize = ModalSize.Small;
  deleteModalText = 'Confirmation Message';
  hideDeletePopUp: boolean = true;
  hideDeletegrpPopUp: boolean = true;
  deleteModalbtnText = 'Yes';
  deleteModalbtncancelText = 'No';

  deleteUserFromGroup: UserGroupModel;
  deleteGroupFromOrg: GroupModel;
  selectUser: UserGroupModel;
  cols: any;

  rolekeyword;
  emailkeyword;

  usertype: string = '';
  fullname: string = '';
  emails: string = '';

  imagePath: any;
  isImagePath = false;

  loggedInUserTypeId: string = '';
  selectedGrpIdInPanel: string = '';

  deletePopup: any;
  role: any;
  panelOpenState: any;

  loggedInUserTypeDesc: string;

  constructor(
    private baseHttpService: BaseHttpService,
    private router: Router,
    private notificationService: NotificationService,
    private globalsession: GlobalsessionhandlerService,
    private paramservice: ParamService,
    public route: ActivatedRoute,
    private authorization: AuthorizationService,
    private globalsessionhandle: GlobalsessionhandlerService,
    private _liveAnnouncer: LiveAnnouncer,
    private spinnerService: NgxSpinnerService,
    private storage: StorageService
  ) {}

  searchForm = new FormGroup({
    name: new FormControl(''),
    email: new FormControl(''),
    role: new FormControl('')
  });

  @ViewChild('searchUserInstance', { static: false }) searchUserInstance: ElementRef;
  @ViewChild('dt', { static: false }) public dataTable: Table;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  searchUserformatter = (user: UserGroupModel) => user.fullName;
  resultUserformatter = (user: UserGroupModel) => user.fullName + '( ' + user.email + ' )';

  public set selectedUser(value: UserGroupModel) {
    if (value !== undefined) {
      this.user = value;
    }
  }

  async ngOnInit() {
    this.loggedInUserTypeId = this.storage.get('LoggedInUserTypeId');
    this.loggedInUserTypeDesc = this.storage.get('LoggedInUserTypeDesc');

    this.cols = [
      { field: 'fullName', header: 'Name' },
      { field: 'email', header: 'Email' },
      { field: 'UserTypeId', header: 'Role' }
    ];

    this.orgName = this.route.snapshot.paramMap.get('Organizationname');
    this.selectedGrpIdInPanel = this.storage.get('selectedGrpInPanel');

    this.loadAllGroup();
  }

  loadAllGroup() {
    this.spinnerService.show();

    const rawUserActivityLog = this.storage.get('UserActivityLog');
    let userlogObj: UserActivityLogModel = null;

    try {
      userlogObj = rawUserActivityLog ? JSON.parse(rawUserActivityLog) : null;
    } catch (e) {
      userlogObj = null;
    }

    const users$ = this.baseHttpService.get(this.constant.getAllUsersGroupRole);
    const groups$ = this.baseHttpService.get(this.constant.getAllGroups);
    const orgs$ = this.baseHttpService.get(this.constant.getAllOrgs);
    const roles$ = this.baseHttpService.get(this.constant.getAllUserRoles);

    forkJoin([users$, groups$, orgs$, roles$]).subscribe(async (results) => {
      this.masterUsers = results[0];
      this.masterGroups = results[1];

      this.masterGroups.forEach((element) => {
        element.deletedUsers = [];
      });

      this.masterOrgs = [];
      this.masterorgsfinal = [];
      this.masterOrgs = results[2];

      // filter only admin groups
      if (this.loggedInUserTypeDesc == 'Group Admin') {
        this.masterOrgs.map((org) => {
          org.groups = org.groups?.filter((group) =>
            group.users?.some((user) => user.userTypeDesc === 'Group Admin')
          );
          return org;
        });
      }

      for (let i = 0, len = this.masterOrgs.length; i < len; i++) {
        if (this.masterOrgs[i].organizationName == this.orgName) {
          this.masterorgsfinal.push(this.masterOrgs[i]);
        }
      }

      this.userList = results[0];
      this.userList1 = results[0];

      this.userTypeList = results[3];
      this.userTypeList = this.userTypeList.filter((x) => x.userTypeId.toString() != 'Super Admin');

      this.paramservice.emitDashboardChange(false);

      for (let user of this.userTypeList) {
        let userType = { label: user.userTypeDesc, value: user.userTypeId };
        if (user.userTypeId == '5') {
          let auth = new AuthorizationService(this.baseHttpService, this.globalsessionhandle);
          let hasaccess = await auth.hasRequiredPermission('Super Admin', '-1', null);
          if (hasaccess) {
            this.userTypes.push(userType);
          }
        } else {
          this.userTypes.push(userType);
        }
      }

      this.masterorgsfinal.forEach(function (x, y) {
        x.isSelected = false;
      });

      this.masterGroups.forEach((element) => {
        element.deletedUsers = [];
      });

      let grpTobeSelceted = new GroupModel();
      this.sortOrgsByName();

      let defaultselectOrg = new OrganizationModel();
      if (this.masterorgsfinal.length > 0) {
        let IsOrgselected = false;
        let result = this.masterorgsfinal.filter((z) => z.groups.length > 0);

        result.forEach(function (x, y) {
          x.groups = x.groups.filter((x) => x.isDefault == false);
          x.groups.forEach(function (a, b) {
            if (IsOrgselected == false) {
              IsOrgselected = true;
              defaultselectOrg = x;
              grpTobeSelceted = a;
              return true;
            }
          });

          if (IsOrgselected) {
            return;
          }
        });

        if (userlogObj != null) {
          if (userlogObj.actionItem == 'User' || userlogObj.actionItem == 'User Role') {
            let userObj = JSON.parse(userlogObj.newValue);
            let orgSel = this.masterorgsfinal.filter((x) => x.organizationId == userObj.OrganizationId)[0];
            this.selectOrg(orgSel);

            let grpSel = this.masterGroups.filter((x) => x.groupId == userObj.GroupId)[0];
            this.selectGroup(grpSel);
            this.updateUserList();

            this.storage.remove('UserActivityLog');
          }
        } else {
          this.selectedGrpIdInPanel = this.storage.get('selectedGroupInPanel');

          if (this.selectedGrpIdInPanel != null) {
            let selOrgIdInPanel = this.storage.get('selectedOrgInPanel');
            let selOrg = this.orgs.find((x) => x.organizationId == selOrgIdInPanel);

            if (selOrg != null) {
              this.selectOrg(selOrg);
              this.orgs = this.masterorgsfinal;

              if (this.orgs != null && this.orgs.length > 0) {
                this.selectedOrgNameValue = selOrg.organizationName;
              }
            }

            let selGrp = this.masterGroups.find(
              (x) => x.groupId == this.selectedGrpIdInPanel && x.organizationId == selOrg.organizationId
            );

            if (selGrp != null) {
              this.selectGroup(selGrp);
              this.updateUserList();
            } else {
              this.selectGroup(grpTobeSelceted);
              this.updateUserList();
            }
          } else {
            if (IsOrgselected) {
              this.selectOrg(defaultselectOrg);
              this.selectGroup(grpTobeSelceted);
              this.updateUserList();
            }

            this.orgs = this.masterorgsfinal;
            if (this.orgs != null && this.orgs.length > 0) {
              this.selectedOrgNameValue = this.orgs[0].organizationName;
            }
          }
        }
      }

      this.Isdataloaded = true;
      this.spinnerService.hide();
    });
  }

  paginate(event: any) {
    if (event == 0) {
      event = 1;
    }
    this.pageIndex = event;
    this.dataSource = this.data.slice(event * this.size - this.size, event * this.size);
  }

  private sortOrgsByName() {
    this.masterorgsfinal.sort((a, b) => {
      let nameA = a.organizationName.toUpperCase();
      let nameB = b.organizationName.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    this.orgs = this.masterorgsfinal;
  }

  changeArrowIcon() {
    this.arrowIconToggle = !this.arrowIconToggle;
  }

  selectOrganization(selectedOrg: OrganizationModel) {
    this.size = 5;
    this.dataSource = [];
    this.showgroupContainer = true;
    this.selectedOrgEdit = selectedOrg;
    this.Organization = selectedOrg;

    this.dataSource = this.Organization.groups.filter((x) => x.isDefault == false);

    this.organizations.forEach((obj) => (obj.isSelected = false));

    this.Organization.isSelected = true;
    this.selectedOrgName = this.Organization.organizationName;
    this.selectedOrgDesc = this.Organization.description;
    this.updateGroupList(selectedOrg.organizationId);
  }

  private updateGroupList(organizationId: any) {
    this.spinnerService.show();
    this.baseHttpService.getById(this.constant.getGroupsByOrgId, organizationId).subscribe((resp: any) => {
      this.masterGroups = resp;
      this.masterGroups = this.masterGroups.filter((x) => x.isDefault == false);
      this.dataSource = this.masterGroups;
      this.data = this.dataSource;
      this.dataSource = this.data.slice(0, 5);
      this.spinnerService.hide();
    });
  }

  selectOrg(org: OrganizationModel) {
    let selectedOrg = this.orgs.find((x) => x.organizationId == org.organizationId);
    if (selectedOrg.isSelected) {
      selectedOrg.isSelected = false;
    } else {
      selectedOrg.isSelected = true;
    }
  }

  selectGroup(selectedGroup: GroupModel) {
    this.isImagePath = false;
    this.size = 5;
    this.pageIndex = 0;
    this.dataSource = [];
    filter: {};

    if (this.searchUserInstance) {
      this.searchUserInstance.nativeElement.value = '';
    }

    this.showgroupContainer = true;

    this.group = this.masterGroups.find((x) => x.groupId == selectedGroup.groupId);

    this.groups.forEach((obj) => (obj.isSelected = false));

    this.group.isSelected = true;
    this.storage.set('selectedGroupInPanel', this.group.groupId);

    this.selectedOrg = this.masterorgsfinal.find((x) => x.organizationId == this.group.organizationId);
    if (this.selectedOrg.logoImage) {
      this.imagePath = 'data:image/jpg;base64,' + this.selectedOrg.logoImage;
      this.isImagePath = true;
    }

    this.updateUserList();
  }

  private async updateUserList() {
    let auth = new AuthorizationService(this.baseHttpService, this.globalsessionhandle);
    let hasAccess = await auth.hasRequiredPermission('Super Admin', '-1', null);

    if (hasAccess) {
      this.users = this.masterUsers.filter((x) => x.groupId == this.group.groupId);
      this.dataSource = this.users;
      this.data = this.dataSource;
      this.dataSource = this.data.slice(0, 5);
      this.sortUsersByName();
    } else {
      this.users = this.masterUsers.filter(
        (x) => x.groupId == this.group.groupId && x.userTypeId != UserTypeId['Organization Admin'].toString()
      );
      this.dataSource = this.users;
      this.data = this.dataSource;
      this.sortUsersByName();
    }
  }

  private sortUsersByName() {
    this.users.sort((a, b) => {
      let nameA = a.fullName.toUpperCase();
      let nameB = b.fullName.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  announceSortChange(sortState: Sort) {
    if (sortState.active == 'fullName') {
      if (sortState.direction == 'asc') {
        let totaldata = this.data;
        let selecteddata = this.dataSource.sort((a, b) => a.fullName.localeCompare(b.fullName));
        const difference = totaldata.filter((ar) => !selecteddata.find((rm) => rm.fullName === ar.fullName));
        let result = selecteddata.concat(difference);
        this.dataSource = result.slice(0, this.dataSource.length);
      }
      if (sortState.direction == 'desc') {
        let totaldata = this.data;
        let selecteddata = this.dataSource.sort((a, b) => b.fullName.localeCompare(a.fullName));
        const difference = totaldata.filter((ar) => !selecteddata.find((rm) => rm.fullName === ar.fullName));
        let result = selecteddata.concat(difference);
        this.dataSource = result.slice(0, this.dataSource.length);
      }
    } else if (sortState.active == 'email') {
      if (sortState.direction == 'asc') {
        let totaldata = this.data;
        let selecteddata = this.dataSource.sort((a, b) => a.email.localeCompare(b.email));
        const difference = totaldata.filter((ar) => !selecteddata.find((rm) => rm.email === ar.email));
        let result = selecteddata.concat(difference);
        this.dataSource = result.slice(0, this.dataSource.length);
      }
      if (sortState.direction == 'desc') {
        let totaldata = this.data;
        let selecteddata = this.dataSource.sort((a, b) => b.email.localeCompare(a.email));
        const difference = totaldata.filter((ar) => !selecteddata.find((rm) => rm.email === ar.email));
        let result = selecteddata.concat(difference);
        this.dataSource = result.slice(0, this.dataSource.length);
      }
    } else if (sortState.active == 'userTypeDesc') {
      if (sortState.direction == 'asc') {
        let totaldata = this.data;
        let selecteddata = this.dataSource.sort((a, b) => a.userTypeDesc.localeCompare(b.userTypeDesc));
        const difference = totaldata.filter((ar) => !selecteddata.find((rm) => rm.userTypeDesc === ar.userTypeDesc));
        let result = selecteddata.concat(difference);
        this.dataSource = result.slice(0, this.dataSource.length);
      }
      if (sortState.direction == 'desc') {
        let totaldata = this.data;
        let selecteddata = this.dataSource.sort((a, b) => b.userTypeDesc.localeCompare(a.userTypeDesc));
        const difference = totaldata.filter((ar) => !selecteddata.find((rm) => rm.userTypeDesc === ar.userTypeDesc));
        let result = selecteddata.concat(difference);
        this.dataSource = result.slice(0, this.dataSource.length);
      }
    }
  }

  addUser() {
    this.spinnerService.show();

    if (this.user != null) {
      if (this.masterUsers.filter((x) => x.groupId == this.group.groupId && this.user.userId == x.userId).length > 0) {
        this.notificationService.showError('User already present in group.', 'Error!');
        this.spinnerService.hide();
      } else {
        this.user.groupId = this.group.groupId;
        this.user.userTypeId = '3';
        this.user.isactive = true;
        this.user.isselected = true;

        let userActivityObj = this.buildUserActivityOject('Update', 'User');
        this.user.userActivityLog = userActivityObj != null ? userActivityObj : null;

        this.baseHttpService.post(this.constant.updateUserRole, this.user).subscribe((groupId: string) => {
          this.notificationService.showSuccess('User has been added to group successfully.', 'Successful!');
          this.user = new UserGroupModel();
          this.selectedUser = new UserGroupModel();

          if (this.searchUserInstance) {
            this.searchUserInstance.nativeElement.value = '';
          }

          this.fetchUser();
          this.spinnerService.hide();
        });
      }
    } else {
      this.notificationService.showError('Please search and select a user to add in group.', 'Error!');
      this.spinnerService.hide();
    }
  }

  buildUserActivityOject(action: string, actionItem: string): UserActivityLogModel {
    this.userActivity = new UserActivityLogModel();
    this.userActivity.action = action;
    this.userActivity.actionItem = actionItem;
    return this.userActivity;
  }

  fetchUser() {
    this.spinnerService.show();
    const users$ = this.baseHttpService.get(this.constant.getAllUsersGroupRole);
    forkJoin([users$]).subscribe((results) => {
      this.masterUsers = results[0];
      if (this.group != null) {
        this.updateUserList();
      }
      this.spinnerService.hide();
    });
  }

  searchUser = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) => {
        if (term === '') return [];

        try {
          const pattern = `(?i).*${term}.*`;
          let result = this.masterUsers
            .filter((user) => {
              if (user.organizationId == this.selectedOrg.organizationId) {
                try {
                  return RE2JS.matches(pattern, user.fullName);
                } catch (error) {
                  return user.fullName.toLowerCase().includes(term.toLowerCase());
                }
              }
              return false;
            })
            .slice(0, 10);

          if (result != null) {
            return result.filter((thing, i, arr) => arr.findIndex((t) => t.userId === thing.userId) === i);
          }
          return result;
        } catch (error) {
          console.error('Error in user search filter:', error);

          let result = this.masterUsers
            .filter(
              (user) =>
                user.organizationId == this.selectedOrg.organizationId &&
                user.fullName.toLowerCase().includes(term.toLowerCase())
            )
            .slice(0, 10);

          if (result != null) {
            return result.filter((thing, i, arr) => arr.findIndex((t) => t.userId === thing.userId) === i);
          }
          return result;
        }
      })
    );

  deleteUser(user: UserGroupModel) {
    this.hideDeletePopUp = false;
    this.deleteUserFromGroup = user;
  }

  closeDelete() {
    this.hideDeletePopUp = true;
    this.deleteUserFromGroup = new UserGroupModel();
  }

  onRowDelete() {
    this.spinnerService.show();

    let selectedUserIndexInUsers = this.users.indexOf(this.deleteUserFromGroup);
    let selectedUserIndexInMasterUsers = this.masterUsers.indexOf(this.deleteUserFromGroup);

    if (selectedUserIndexInUsers > -1) {
      this.users.splice(selectedUserIndexInUsers, 1);
      if (selectedUserIndexInMasterUsers > -1) {
        this.masterUsers.splice(selectedUserIndexInMasterUsers, 1);
      }

      this.deleteUserFromGroup.isactive = false;

      let userActivityObj = this.buildUserActivityOject('Delete', 'User');
      this.deleteUserFromGroup.userActivityLog = userActivityObj != null ? userActivityObj : null;

      this.baseHttpService.post(this.constant.updateUserRole, this.deleteUserFromGroup).subscribe((groupId: string) => {
        delete this.clonedUser[this.deleteUserFromGroup.userId];
        this.editingrow = false;

        this.notificationService.showSuccess('User role has been deleted successfully.', 'Successful!');

        this.dataSource = [];
        this.dataSource = this.users;
        this.data = this.dataSource;
        this.dataSource = this.data.slice(0, 5);

        this.sortUsersByName();
        this.hideDeletePopUp = true;

        this.spinnerService.hide();
      });
    }
  }

  deleteGroup(grp: any) {
    this.deleteGroupFromOrg = grp;
    this.hideDeletegrpPopUp = false;
  }

  closegrpDelete() {
    this.hideDeletegrpPopUp = true;
  }

  confirmDelete() {
    this.spinnerService.show();

    let existingItem = this.masterGroups.find((i) => i.groupId == this.deleteGroupFromOrg.groupId);

    if (this.masterGroups.indexOf(existingItem) > -1) {
      this.group = {
        organizationId: this.Organization.organizationId,
        groupId: existingItem.groupId,
        groupName: existingItem.groupName,
        groupDescription: existingItem.groupDescription,
        users: [],
        isDefault: false,
        isActive: false,
        isSelected: false
      };

      let userActivityObj = this.buildUserActivityOject('Delete', 'Group');
      this.group.userActivityLog = userActivityObj != null ? userActivityObj : null;

      this.baseHttpService.post(this.constant.deleteGroup, this.group).subscribe((result: string) => {
        this.notificationService.showSuccess('Group has been deleted successfully.', 'Successful!');

        this.masterGroups.splice(this.masterGroups.indexOf(existingItem), 1);
        let updtGrp = this.masterGroups;

        this.dataSource = [];
        this.dataSource = this.masterGroups;
        this.groups = updtGrp;

        this.data = this.dataSource;
        this.dataSource = this.data.slice(0, 5);

        this.orgName = this.route.snapshot.paramMap.get('Organizationname');
        this.hideDeletegrpPopUp = true;

        this.loadAllGroup();
        this.spinnerService.hide();
      });
    }
  }

  editGroup(grp: any) {
    this.router.navigate([
      '/create/createGroup',
      {
        grpid: grp.groupId,
        orgid: grp.organizationId,
        grpname: grp.groupName,
        grpdesc: grp.groupDescription,
        page: 'Editgroupuser',
        orgname: this.orgName
      }
    ]);
  }

  deletedgroup() {
    this.spinnerService.show();

    const rawUserActivityLog = this.storage.get('UserActivityLog');
    let userlogObj: UserActivityLogModel = null;

    try {
      userlogObj = rawUserActivityLog ? JSON.parse(rawUserActivityLog) : null;
    } catch (e) {
      userlogObj = null;
    }

    const orgs$ = this.baseHttpService.get(this.constant.getAllOrgs);
    forkJoin([orgs$]).subscribe(async (results) => {
      this.masterOrgs = results[0];
      for (let i = 0, len = this.masterOrgs.length; i < len; i++) {
        if (this.masterOrgs[i].organizationName == this.orgName) {
          this.masterorgsfinal.push(this.masterOrgs[i]);
        }
      }
      this.spinnerService.hide();
    });
  }

  roleLevelChangeAction(role) {
    this.rolekeyword = role;

    if (this.dataSource.length > 0 && this.rolekeyword !== undefined) {
      for (let i = 0, len = this.dataSource.length; i < len; i++) {
        if (this.dataSource[i].userTypeId == this.rolekeyword) {
          this.rolefilter.push(this.dataSource[i]);
          const result = this.rolefilter.filter((x) => x.userTypeId == this.rolekeyword);
          this.dataSource = [];
          this.dataSource = result;
          this.dataSource = this.dataSource.filter((x) => x.userTypeId == this.rolekeyword);
          return;
        }
      }
    } else {
      if (this.rolekeyword == undefined) {
        this.dataSource = [];
        this.dataSource = this.data;
        return;
      }
    }

    this.dataSource = [];
    this.dataSource = this.data;
    const result = this.dataSource.filter((x) => x.userTypeId == this.rolekeyword);
    this.dataSource = result;
    return;
  }

  fullNameChangeAction(keyword) {
    if (this.dataSource.length > 0) {
      for (let i = 0, len = this.dataSource.length; i < len; i++) {
        if (this.dataSource[i].fullName == keyword) {
          const result = this.dataSource.filter((x) => x.fullName.toUpperCase().includes(keyword.toUpperCase()), 'fullName', 'contains');
          this.dataSource = result;
        }
      }

      this.dataSource = this.data;
      const result = this.dataSource.filter((x) => x.fullName.toUpperCase().includes(keyword.toUpperCase()), 'fullName', 'contains');
      this.dataSource = result;
    } else {
      this.dataSource = this.data;
      const result = this.dataSource.filter((x) => x.fullName.toUpperCase().includes(keyword.toUpperCase()), 'fullName', 'contains');
      this.dataSource = result;
    }
  }

  emailChangeAction(keyword) {
    this.emailkeyword = keyword;

    if (this.dataSource.length > 0) {
      for (let i = 0, len = this.dataSource.length; i < len; i++) {
        if (this.dataSource[i].email == keyword) {
          const result = this.dataSource.filter((x) => x.email.toUpperCase().includes(this.emailkeyword.toUpperCase()));
          this.dataSource = result;
        }
      }

      this.dataSource = this.data;
      const result = this.dataSource.filter((x) => x.email.toUpperCase().includes(keyword.toUpperCase()));
      this.dataSource = result;
    } else {
      this.dataSource = this.data;
    }
  }

  filterselection() {
    this.dataSource = this.data;

    if (this.searchForm.controls['role'].value != undefined) {
      this.usertype = this.searchForm.controls['role'].value;
      this.usertype = this.usertype.toString();
    } else {
      this.usertype = '';
    }

    this.fullname = this.searchForm.controls['name'].value;
    if (this.fullname != '') this.fullname = this.fullname.trim().toLowerCase();

    this.emails = this.searchForm.controls['email'].value;
    if (this.emails != '') this.emails = this.emails.trim().toLowerCase();

    if (
      this.searchForm.controls['email'].value == '' &&
      this.searchForm.controls['name'].value == '' &&
      this.fullname == '' &&
      this.usertype == '' &&
      this.emails == ''
    ) {
      this.dataSource = this.data;
      this.dataSource = this.dataSource.slice(0, this.size);
      return;
    }

    let result = this.dataSource.filter(
      (x) =>
        (this.usertype.length > 0 &&
          this.fullname.length > 0 &&
          this.emails.length > 0 &&
          x.userTypeId == this.usertype &&
          x.fullName.trim().toLowerCase().includes(this.fullname) &&
          x.email.trim().toLowerCase().includes(this.emails)) ||
        (this.usertype.length > 0 &&
          this.fullname.length > 0 &&
          this.emails.length == 0 &&
          x.userTypeId == this.usertype &&
          x.fullName.trim().toLowerCase().includes(this.fullname)) ||
        (this.usertype.length > 0 &&
          this.emails.length > 0 &&
          this.fullname.length == 0 &&
          x.userTypeId == this.usertype &&
          x.email.trim().toLowerCase().includes(this.emails)) ||
        (this.fullname.length > 0 &&
          this.emails.length > 0 &&
          this.usertype.length == 0 &&
          x.fullName.trim().toLowerCase().includes(this.fullname) &&
          x.email.trim().toLowerCase().includes(this.emails)) ||
        (this.usertype != '' && x.userTypeId == this.usertype && this.fullname == '' && this.emails == '') ||
        (this.fullname.length > 0 &&
          x.fullName.trim().toLowerCase().includes(this.fullname) &&
          this.usertype == '' &&
          this.emails == '') ||
        (this.emails.length > 0 &&
          x.email.trim().toLowerCase().includes(this.emails) &&
          this.usertype == '' &&
          this.fullname == '')
    );

    this.dataSource = result;
  }

  onRowEditInit(user: UserGroupModel) {
    this.editingrow = true;
    this.selectUser = user;
    this.clonedUser[user.userId] = { ...user };
  }

  onRowEditSave(user: UserGroupModel) {
    this.spinnerService.show();

    user.userTypeDesc = this.userTypeList.filter((x) => x.userTypeId == user.userTypeId).map((x) => x.userTypeDesc)[0];
    user.isactive = true;

    let userActivityObj = this.buildUserActivityOject('Update', 'User Role');
    user.userActivityLog = userActivityObj != null ? userActivityObj : null;

    this.baseHttpService.post(this.constant.updateUserRole, user).subscribe((groupId: string) => {
      delete this.clonedUser[user.userId];
      this.spinnerService.hide();
      this.notificationService.showSuccess('User role has been updated successfully.', 'Successful!');
      this.editingrow = false;
    });
  }

  onRowEditCancel(user: UserGroupModel, index: number) {
    this.editingrow = false;
    this.userList1[index] = this.clonedUser[user.userId];
    delete this.clonedUser[user.userId];
  }

  addGroupUser() {
    this.router.navigate(['create/createGroupUsers', { Organizationname: this.orgName }]);
  }

  applySearch(event) {
    this.filterselection();
    console.log(this.searchForm);
  }

  resetSearch(event) {
    this.searchForm.controls['name'].setValue('');
    this.searchForm.controls['email'].setValue('');
    this.searchForm.controls['role'].setValue(undefined);
    this.filterselection();
  }
}
